export const CLEAR_SEARCH_TERM = "UI/MY_IMAGES/CLEAR_SEARCH_TERM";
export const IMAGE_SEARCH_REQUEST = "UI/MY_IMAGES/IMAGE_SEARCH_REQUEST";
